window.initializeOrganaxSearchPage = () => {
  const root = document.querySelector('.organax-search-page');
  if (!root) return;
  if (root.dataset.collectionUiReady) return;
  root.dataset.collectionUiReady = 'true';
  const lifecycle = new AbortController();
  document.addEventListener('organax:collection-ui-dispose', () => lifecycle.abort(), { once: true, signal: lifecycle.signal });
  root.classList.add('is-enhanced');

  if (root.classList.contains('organax-brand-page')) {
    const alternateView = new URLSearchParams(location.search).get('view') === 'brand';
    if (alternateView) {
      root.querySelectorAll('form').forEach((form) => {
        if (form.id === 'FacetSortForm' || form.id === 'FacetSortDrawerForm') return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'view';
        input.value = 'brand';
        form.append(input);
      });
    }
    root.addEventListener('click', (event) => {
      const categoryLink = event.target.closest('.organax-brand-categories a');
      if (!categoryLink) return;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = new URL(categoryLink.href);
      if (target.origin !== location.origin || target.pathname !== location.pathname || typeof FacetFiltersForm === 'undefined') return;
      event.preventDefault();
      if (alternateView) target.searchParams.set('view', 'brand');
      FacetFiltersForm.renderPage(target.searchParams.toString());
    });
  }

  const visibleCount = root.querySelector('#ProductCountDesktop');
  if (visibleCount) {
    const formatCount = () => {
      const value = visibleCount.textContent.trim();
      if (value.startsWith('Showing') || value.startsWith('No results')) return;
      const total = Number(value.match(/[\d,]+/)?.[0].replaceAll(',', ''));
      const displayed = root.querySelectorAll('.organax-search-page__grid > li').length;
      if (!total || !displayed) return;
      const page = Number(new URLSearchParams(window.location.search).get('page')) || 1;
      const first = (page - 1) * 10 + 1;
      visibleCount.textContent = `Showing ${first}–${first + displayed - 1} of ${total} results`;
    };
    new MutationObserver(formatCount).observe(visibleCount, { childList: true, subtree: true });
  }

  const sortDetails = root.querySelector('.organax-search-page__sort-details');
  root.querySelectorAll('.organax-search-page__sort-options button').forEach((option) => {
    option.addEventListener('click', (event) => {
      const nativeSort = root.querySelector('#SortBy');
      if (!nativeSort) return;
      event.preventDefault();
      nativeSort.value = option.value;
      nativeSort.dispatchEvent(new Event('input', { bubbles: true }));
      root.querySelector('.organax-search-page__sort-current').textContent = option.dataset.sortShortLabel;
      root.querySelectorAll('.organax-search-page__sort-options button').forEach((button) => button.removeAttribute('aria-current'));
      option.setAttribute('aria-current', 'true');
      sortDetails.open = false;
      sortDetails.querySelector('summary').focus();
    });
  });
  document.addEventListener('pointerdown', (event) => {
    if (sortDetails?.open && !sortDetails.contains(event.target)) sortDetails.open = false;
  }, { signal: lifecycle.signal });
  sortDetails?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && sortDetails.open) {
      event.preventDefault();
      sortDetails.open = false;
      sortDetails.querySelector('summary').focus();
    }
  });

  root.addEventListener('click', (event) => {
    const priceOption = event.target.closest('.organax-search-price-options__item');
    if (!priceOption) return;
    const desktopForm = root.querySelector('#FacetFiltersForm');
    const mobileForm = root.querySelector('#FacetFiltersFormMobile');
    const form = getComputedStyle(root.querySelector('.mobile-facets__wrapper')).display !== 'none' ? mobileForm : desktopForm;
    const min = form?.querySelector('price-range input[name$=".gte"]');
    const max = form?.querySelector('price-range input[name$=".lte"]');
    if (!min || !max) return;
    event.preventDefault();
    const clear = min.value === priceOption.dataset.priceMin && max.value === priceOption.dataset.priceMax;
    min.value = clear ? '' : priceOption.dataset.priceMin;
    max.value = clear ? '' : priceOption.dataset.priceMax;
    max.dispatchEvent(new Event('input', { bubbles: true }));
    root.querySelectorAll('.organax-search-price-options__item').forEach((item) => {
      const selected = item.dataset.priceMin === min.value && item.dataset.priceMax === max.value;
      item.classList.toggle('is-selected', selected);
      if (selected) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
  });

  const toggle = root.querySelector('.organax-search-page__filter-toggle');
  const drawer = root.querySelector('.mobile-facets__disclosure');
  const summary = drawer?.querySelector(':scope > summary');
  toggle?.addEventListener('click', () => summary?.click());
  root.querySelector('[data-organax-close-filters]')?.addEventListener('click', () => {
    if (drawer?.open) summary?.click();
    toggle?.focus();
  });
  if (toggle && drawer) {
    const update = () => toggle.setAttribute('aria-expanded', String(drawer.open));
    new MutationObserver(update).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    update();
  }

  // Apply entry defaults through the existing section renderer, with one request
  // and no full document redirect. Later checkbox/clear/history actions stay native.
  const defaults = new URLSearchParams(location.search);
  if (!window.Shopify?.designMode && !Object.prototype.hasOwnProperty.call(history.state || {}, 'searchParams') && !defaults.has('section_id') && typeof FacetFiltersForm !== 'undefined') {
    let changed = false;
    if (!defaults.has('filter.v.availability') && ![...defaults.keys()].some(key => key.startsWith('filter.')) && !defaults.has('page')) {
      const available = root.querySelector('input[name="filter.v.availability"][value="1"]:not(:disabled)');
      if (available) {
        defaults.set('filter.v.availability', '1');
        changed = true;
      }
    }
    if (root.classList.contains('organax-brand-page') && !defaults.has('sort_by')) {
      defaults.set('sort_by', 'best-selling');
      root.querySelectorAll('select[name="sort_by"]').forEach(select => { select.value = 'best-selling'; });
      const label = root.querySelector('.organax-search-page__sort-current');
      if (label) label.textContent = 'Popularity';
      changed = true;
    }
    if (changed) {
      const params = defaults.toString();
      history.replaceState({ searchParams: params }, '', `${location.pathname}?${params}${location.hash}`);
      FacetFiltersForm.searchParamsInitial = params;
      FacetFiltersForm.renderPage(params, null, false);
    }
  }

  root.addEventListener('click', (event) => {
      const mobileForm = root.querySelector('#FacetFiltersFormMobile');
      if (!mobileForm) return;
      if (event.target.closest('[data-organax-clear-filters]')) {
        mobileForm.querySelectorAll('input[name^="filter."]').forEach((input) => {
          if (input.type === 'checkbox') input.checked = false;
          else input.value = '';
        });
        mobileForm.querySelectorAll('.organax-search-price-options__item.is-selected').forEach((item) => item.classList.remove('is-selected'));
        const clearParams = new URLSearchParams(new FormData(mobileForm));
        [...clearParams.keys()].forEach((key) => {
          if (key.startsWith('filter.') || key === 'page') clearParams.delete(key);
        });
        if (typeof FacetFiltersForm !== 'undefined') FacetFiltersForm.renderPage(clearParams.toString(), event);
        else window.location.assign(`${location.pathname}?${clearParams}`);
        if (drawer?.open) summary?.click();
        return;
      }
      if (!event.target.closest('[data-organax-apply-filters]')) return;
      const params = new URLSearchParams(new FormData(mobileForm)).toString();
      if (typeof FacetFiltersForm !== 'undefined') FacetFiltersForm.renderPage(params, event);
      else window.location.assign(`${location.pathname}?${params}`);
      summary?.click();
  });

  const loadStatus = document.createElement('p');
  loadStatus.className = 'visually-hidden';
  loadStatus.setAttribute('role', 'status');
  loadStatus.setAttribute('aria-live', 'polite');
  root.append(loadStatus);

  root.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-organax-load-more]');
    if (!link) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    const grid = root.querySelector('.organax-search-page__grid');
    if (!grid || grid.closest('.collection')?.classList.contains('loading')) return;
    const requestUrl = link.href;
    const pageContext = location.href;
    const stillCurrent = () => link.isConnected && root.querySelector('.organax-search-page__grid') === grid && location.href === pageContext && !grid.closest('.collection')?.classList.contains('loading');
    const idleLabel = link.textContent;
    link.setAttribute('aria-busy', 'true');
    link.setAttribute('aria-disabled', 'true');
    link.textContent = 'Loading products…';
    loadStatus.textContent = 'Loading more products.';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(requestUrl, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error(`Search page request failed: ${response.status}`);
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = documentFragment.querySelector('.organax-search-page__grid');
      if (!nextGrid?.children.length) throw new Error('Search results were missing from the next page');
      // Filtering or sorting can replace the grid while this request is pending.
      if (!stillCurrent()) return;
      const newCards = [...nextGrid.children];
      grid.append(...newCards);
      const nextLink = documentFragment.querySelector('[data-organax-load-more]');
      if (nextLink) {
        link.href = nextLink.href;
      } else {
        if (document.activeElement === link) newCards[0].querySelector('a')?.focus({ preventScroll: true });
        link.remove();
      }
      const nextCount = documentFragment.querySelector('#ProductCountDesktop');
      const currentCount = root.querySelector('#ProductCountDesktop');
      const total = nextCount?.textContent.match(/of\s+([\d,]+)\s+results/);
      const first = currentCount?.textContent.match(/Showing\s+([\d,]+)/)?.[1] || '1';
      if (total && currentCount) currentCount.textContent = `Showing ${first}–${Number(first.replaceAll(',', '')) + grid.children.length - 1} of ${total[1]} results`;
      loadStatus.textContent = `${newCards.length} more products loaded.${nextLink ? '' : ' All results are now shown.'}`;
    } catch (error) {
      if (stillCurrent()) window.location.assign(requestUrl);
    } finally {
      clearTimeout(timeout);
      link.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
      link.textContent = idleLabel;
      if (loadStatus.textContent === 'Loading more products.') loadStatus.textContent = '';
    }
  });
};
window.initializeOrganaxSearchPage();

